import React from "react"
import { useLabels } from "../../../../../../features/contents/hooks"
import Slide from "../../../../../../ui/animations/Slide"
import CustomButton from "../../../../../../ui/atoms/Button"
import Typography from "../../../../../../ui/atoms/Typography"
import { ArrowBackIcon } from "../../../../../../ui/icons"
import classes from "./FilterCategoryContainer.module.css"

interface Props {
  show: boolean
  onBack: () => void
  children?: any
}

const FilterCategoryContainer = ({ show, onBack, children }: Props) => {
  const { getLabel } = useLabels()
  return (
    <Slide jsHidden in={show} from="right" style={{ height: "100%" }}>
      <div
        style={{ top: 35, zIndex: 1000 }}
        className={`sticky left-0 w-full bg-white ${classes.head}`}
      >
        <CustomButton
          onClick={onBack}
          variant="text"
          invariantCase
          classes={{ inner: "flex items-center" }}
        >
          <ArrowBackIcon className={classes.back} />
          <Typography variant="body2" lineHeightValue="16px" component="span">
            {getLabel("search", "back")}
          </Typography>
        </CustomButton>
      </div>
      <div className="h-full px-1 pb-4">{children}</div>
    </Slide>
  )
}

export default FilterCategoryContainer
